import { useMediaQuery, useTheme } from "@mui/material";

export const useDrawerMaxWidth = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));
  const isLgDown = useMediaQuery(theme.breakpoints.down("lg"));

  if (isMobile) {
    // mobile has one full-width pane
    return 600;
  } else if (isMdDown) {
    return 300;
  } else if (isLgDown) {
    // tablet has two 400px panes
    return 400;
  } else {
    // desktop has two 500px panes, mobile has one
    return 500;
  }
};
